import React, { useEffect, useState } from "react";
import {
  Link
} from "react-router-dom";
import {
  Plus,
  Eye,
  Wallet
} from "lucide-react";
import * as ownerApi from "../../api/payroll/payrollApi";
import * as portalApi from "../../api/payroll/payrollPortalApi";
import PayrollStatusBadge from "../../components/payroll/PayrollStatusBadge";
import {
  Button,
  Card,
  CardContent,
  Table,
  EmptyState
} from "../../components/ui";
import {
  useToast
} from "../../context/ToastContext";

const MONTHS = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export default function PayrollRunList({ isPortal = false }) {
  const api = isPortal ? portalApi : ownerApi;
  const basePath = isPortal ? "/staff-panel/payroll-runs" : "/payroll-runs";

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await api.getAllPayrollRuns();
        setItems(Array.isArray(res) ? res : res.data || []);
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to load");
      } finally {
        setLoading(false);
      }
    })();
  }, [isPortal, api]);

  // ---- Presentation-only derivations below (no data/logic changes) ----

  const tableRows = items.map((run) => ({ ...run, id: run._id }));

  const columns = [
    {
      key: "period",
      header: "Period",
      render: (run) => (
        <span className="font-medium text-neutral-900 dark:text-neutral-100">
          {MONTHS[run.month]} {run.year}
        </span>
      ),
    },
    {
      key: "status",
      header: "Status",
      render: (run) => <PayrollStatusBadge status={run.status} />,
    },
    { key: "totalStaffCount", header: "Staff" },
    {
      key: "totalGrossPay",
      header: "Gross",
      align: "right",
      render: (run) => `₹${Number(run.totalGrossPay || 0).toLocaleString()}`,
    },
    {
      key: "totalDeductions",
      header: "Deductions",
      align: "right",
      render: (run) => `₹${Number(run.totalDeductions || 0).toLocaleString()}`,
    },
    {
      key: "totalNetPay",
      header: "Net",
      align: "right",
      render: (run) => (
        <span className="font-semibold text-neutral-900 dark:text-neutral-100">
          ₹{Number(run.totalNetPay || 0).toLocaleString()}
        </span>
      ),
    },
    {
      key: "actions",
      header: "Actions",
      align: "right",
      nowrap: true,
      render: (run) => (
        <Link to={`${basePath}/${run._id}`}>
          <Button type="button" variant="ghost" size="xs" leftIcon={<Eye className="h-3.5 w-3.5" />}>
            View
          </Button>
        </Link>
      ),
    },
  ];

  return (
    <div className="mx-auto max-w-5xl space-y-6 p-4 sm:p-6">
      <div className="flex flex-col gap-4 border-b border-neutral-200 dark:border-neutral-800 pb-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-xl font-semibold tracking-tight text-neutral-900 dark:text-neutral-100 sm:text-2xl">
            Payroll Runs
          </h1>
          <p className="mt-1 text-sm text-neutral-500 dark:text-neutral-400">
            Monthly payroll generation history and totals
          </p>
        </div>
        <Link to={`${basePath}/create`}>
          <Button variant="primary" leftIcon={<Plus className="h-4 w-4" />}>
            Generate Run
          </Button>
        </Link>
      </div>

      

      <Card>
        <CardContent className="p-0">
          <Table
            columns={columns}
            data={tableRows}
            isLoading={loading}
            emptyState={
              <EmptyState
                icon={Wallet}
                title="No payroll runs yet"
                description="Generate a run to process staff pay for a period."
                action={
                  <Link to={`${basePath}/create`}>
                    <Button variant="primary" size="sm" leftIcon={<Plus className="h-4 w-4" />}>
                      Generate Run
                    </Button>
                  </Link>
                }
              />
            }
          />
        </CardContent>
      </Card>
    </div>
  );
}